import React from 'react';

import { Sorting } from 'src/components/Sorting';
import type { SortingPosition } from 'src/components/Sorting/types';
import { SORT_TYPES_REVIEWS } from 'src/components/Sorting/constants';
import { SwiperFilterButtonList } from 'src/components/Reviews/components/FilterButtonList/SwiperFilterButtonList';
import type { FiltersProps } from '@lt/api/dist/methods/hotelReviews/types';
import styles from '../reviews.module.css';
import type { ReviewListProps } from './ReviewList/ReviewList';
import { ReviewList } from './ReviewList/ReviewList';

type ReviewsDesktopProps = ReviewListProps & {
  hasReviewsSection: boolean;
  sorting: SortingPosition;
  onChangeSorting: ({ order, field }: SortingPosition) => void;
  filters: FiltersProps[];
  onChangeFilters: ({
    name,
    isSelected,
  }: {
    name: string;
    isSelected: boolean;
  }) => void;
};

const ReviewsMobile = ({
  hasReviewsSection,
  isShowMoreReviews,
  isFetching,
  items,
  showMore,
  isLoadingNew,
  onChangeSorting,
  sorting,
  filters,
  onChangeFilters,
  isErrorResult,
  onClickRetry,
}: ReviewsDesktopProps) => (
  <div className={styles.reviewsContainer}>
    <SwiperFilterButtonList filters={filters} onClickButton={onChangeFilters} />
    {hasReviewsSection && (
      <Sorting
        className={styles.sorting}
        isMapView={false}
        isMobile
        field={sorting.field}
        awaitFiltration={false}
        changeSorting={onChangeSorting}
        sortTypes={SORT_TYPES_REVIEWS}
        order={sorting.order}
      />
    )}
    <ReviewList
      items={items}
      isShowMoreReviews={isShowMoreReviews}
      showMore={showMore}
      isLoadingNew={isLoadingNew}
      isFetching={isFetching}
      isErrorResult={isErrorResult}
      onClickRetry={onClickRetry}
    />
  </div>
);

export default ReviewsMobile;
